module.exports = __webpack_public_path__ + "img/pin-white.59596e2b.svg";